import React, { FC } from 'react';
import * as translations from '../design_assets/strings';
import { getLangKey } from 'appJS/models/Language';
import styles from '../design_assets/index.module.css';
import { Button } from 'antd';
import { Share, ExternalLink } from 'lucide-react';

const strings = translations[getLangKey()];

type Props = {
  id: number;
  projectId?: number;
  url: string;
  disabled: boolean;
  onShareClick?: (event: any) => any;
  showShareHover?: boolean;
  loggedIn?: boolean;
};

const AssetImage: FC<Props> = ({
  id,
  projectId,
  url,
  disabled,
  onShareClick,
  showShareHover,
  loggedIn
}) => {
  return disabled ? (
    <div className={styles.imgWrapper}>
      <img
        className={styles.grayscale}
        width={280}
        height={165}
        src={url}
        crossOrigin="anonymous"
      />
      <div className={styles.archived}>{strings.archived}</div>
    </div>
  ) : (
    <div className={styles.imgWrapper}>
      {onShareClick && showShareHover && (
        <HoverShareButton
          onShareClick={onShareClick}
          projectId={projectId}
          id={id}
          loggedIn={loggedIn}
        />
      )}
      <img width={280} height={165} src={url} crossOrigin="anonymous" />
    </div>
  );
};

export default AssetImage;

type HoverShareButtonProps = {
  onShareClick: (event: any) => any;
  projectId?: number;
  id: number;
  loggedIn?: boolean;
};

export const HoverShareButton = ({
  onShareClick,
  projectId,
  id,
  loggedIn
}: HoverShareButtonProps) => {
  return (
    <div className={styles.slideInButtonWrapper}>
      <div className={styles.cardHoverInfoContainer}>
        {projectId && (
          <Button
            icon={<ExternalLink size={20} />}
            className={styles.openButton}
            type="primary"
            // parent AssetCard click handles opening the file
          >
            Open file
          </Button>
        )}
        {/* Hide the share asset button for non-logged in users */}
        {loggedIn !== false && (
          <Button
            className={styles.cardShareButton}
            type="link"
            icon={<Share size={20} />}
            onClick={onShareClick}
          >
            Share
          </Button>
        )}
      </div>
    </div>
  );
};
